import * as yup from "yup";

const ManageHomeSchema = yup.object().shape({
  first_name: yup.string().required().label("First name"),
});

export default ManageHomeSchema;
